<div class="flex flex-col">
  <div class="flex flex-row">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
                'bg-gray-600': sharedService.userTheme === 'dark',
                'bg-indigo-50': sharedService.userTheme === 'light'}">

      <div class="flex flex-row padding10">
        <h5>Survey Reports</h5>
      </div>
    </mat-card>
  </div>

  <div class="flex flex-row">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
        'bg-gray-600': sharedService.userTheme === 'dark',
        'bg-indigo-50': sharedService.userTheme === 'light'}">
      <mat-card-content>
        <form [formGroup]="reportGroup" class="w-full">
          <div class="flex flex-col">

            <div style="overflow-x:auto">
              <div class="flex flex-row">
                <table class="mat-elevation-z8 w-full">
                  <tr class="">
                    <th>Report Name </th>
                    <th>Description</th>
                    <th>
                    </th>
                  </tr>
                  <tr>
                    <td>Survey Report</td>
                    <td>All surveys for a given month and year.</td>
                    <td>
                      <div class="flex flex-row">
                        <mat-form-field>
                          <mat-label>Survey Type</mat-label>
                          <mat-select formControlName="SurveyType">
                            <mat-option value="All">All</mat-option>
                            <mat-option *ngFor="let types of surveyTypes" [value]="types.key">{{types.value}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>

                        <mat-form-field>
                          <mat-label>Month</mat-label>
                          <mat-select formControlName="Month0">
                            <mat-option *ngFor="let types of months" [value]="types.key">{{types.value}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <mat-form-field>
                          <mat-label>Year</mat-label>
                          <mat-select formControlName="Year0">
                            <mat-option *ngFor="let types of years" [value]="types.key">{{types.value}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <mat-form-field>
                          <mat-label>Surveyor</mat-label>
                          <mat-select formControlName="Surveyor0">
                            <mat-option value="Everyone">Everyone</mat-option>
                            <mat-option *ngFor="let types of surveyorList" [value]="types.initials">{{types.initials}} -
                              {{types.fullname}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>

                        <div>
                          <button type="button" mat-raised-button color="primary" (click)="surveyReport()">
                            Run Report
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>Follow up Done</td>
                    <td>All Followupds done within the last 6 months.</td>
                    <td>
                      <button type="button" mat-raised-button color="primary" (click)="followupReport()">
                        Run Report
                      </button>
                  </tr>
                  <tr>
                    <td>Registration Labs</td>
                    <td>Registration labs to be inspected.</td>
                    <td>
                      <button type="button" mat-raised-button color="primary" (click)="registrationReport()">
                        Run Report
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <td>Deficiency Reports</td>
                    <td>Deficiency Reports, POC & SOD</td>
                    <td>
                      <div class="flex flex-row">
                        <div class="flex flex-col">
                          <div class="flex flex-row">
                            <mat-form-field>
                              <mat-label>Surveyor</mat-label>
                              <mat-select formControlName="Surveyor3">
                                <mat-option value="All">Everyone</mat-option>
                                <mat-option *ngFor="let types of surveyorList" [value]="types.initials">
                                  {{types.initials}} -
                                  {{types.fullname}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                            <mat-form-field>
                              <mat-label>Type</mat-label>
                              <mat-select formControlName="Type3">
                                <mat-option value="POC">POC</mat-option>
                                <mat-option value="SOD">SOD</mat-option>
                              </mat-select>
                            </mat-form-field>

                          </div>
                          <div class="flex flex-row">
                            <div style="padding-right: 5px;">From:</div>
                            <mat-form-field>
                              <mat-label>Month</mat-label>
                              <mat-select formControlName="Month3_0">
                                <mat-option *ngFor="let types of months" [value]="types.key">{{types.value}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                            <mat-form-field>
                              <mat-label>Year</mat-label>
                              <mat-select formControlName="Year3_0">
                                <mat-option *ngFor="let types of years" [value]="types.key">{{types.value}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                            <div style="padding-right: 5px;">To:</div>
                            <mat-form-field>
                              <mat-label>Month</mat-label>
                              <mat-select formControlName="Month3_0">
                                <mat-option *ngFor="let types of months" [value]="types.key">{{types.value}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                            <mat-form-field>
                              <mat-label>Year</mat-label>
                              <mat-select formControlName="Year3_0">
                                <mat-option *ngFor="let types of years" [value]="types.key">{{types.value}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                        </div>
                        <div>
                          <button type="button" mat-raised-button color="primary" (click)="deficiencyReport()">
                            Run Report
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>Deficiency Reports</td>
                    <td>Unresolved Deficiencies, POC & SOD</td>
                    <td>
                      <div class="flex flex-row">
                        <div style="padding-right: 5px;">From:</div>
                        <mat-form-field>
                          <mat-label>Month</mat-label>
                          <mat-select formControlName="Month4_0">
                            <mat-option value=""></mat-option>
                            <mat-option *ngFor="let types of months" [value]="types.key">{{types.value}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <mat-form-field>
                          <mat-label>Year</mat-label>
                          <mat-select formControlName="Year4_0">
                            <mat-option value=""></mat-option>
                            <mat-option *ngFor="let types of years" [value]="types.key">{{types.value}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <div style="padding-right: 5px;">To:</div>
                        <mat-form-field>
                          <mat-label>Month</mat-label>
                          <mat-select formControlName="Month4_1">
                            <mat-option *ngFor="let types of months" [value]="types.key">{{types.value}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <mat-form-field>
                          <mat-label>Year</mat-label>
                          <mat-select formControlName="Year4_1">
                            <mat-option *ngFor="let types of years" [value]="types.key">{{types.value}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <div>
                          <button type="button" mat-raised-button color="primary"
                            (click)="unresolvedDeficienciesReport()">
                            Run Report
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </form>
      </mat-card-content>

    </mat-card>
  </div>

  <kendo-pdf-export #pdf paperSize="letter" [scale]="0.6" margin="1cm">
    <!-- Survey Report -->
    <div class="flex flex-col" *ngIf="reportMode == 'survey'">
      <div class="flex flex-row">
        <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
          'bg-gray-700': sharedService.userTheme === 'dark',
          'bg-indigo-50': sharedService.userTheme === 'light'}">
          <mat-card-content>
            <div class="flex flex-col">
              <h5>Labs Surveyed in {{mon}}/{{yr}} ({{list.length}})</h5>
              <div class="flex flex-row" style="padding-bottom: 10px;" *ngIf="list.length > 0">
                <div style="padding-right: 10px;">
                  <button type="button" mat-raised-button (click)="csv('survey')">
                    CSV
                  </button>
                </div>
                <!-- <div>
                  <button type="button" mat-raised-button (click)="pdf.saveAs('SurveyReport.pdf')">
                    PDF
                  </button>
                </div> -->
              </div>
              <div style="overflow-x:auto">
                <div class="flex flex-row" *ngIf="list.length > 0">
                  <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort #TableSort="matSort"
                    class="mat-elevation-z8 w-full">
                    <ng-container matColumnDef="stateNumber">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>State #</th>
                      <td mat-cell *matCellDef="let item">{{item.scheduleType}} {{item.stateNumber}}</td>
                    </ng-container>
                    <ng-container matColumnDef="cliaNumber">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Clia #</th>
                      <td mat-cell *matCellDef="let item">{{item.cliaNumber}}</td>
                    </ng-container>
                    <ng-container matColumnDef="labName">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Lab Name</th>
                      <td mat-cell *matCellDef="let item">{{item.labName}}</td>
                    </ng-container>
                    <ng-container matColumnDef="city">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>City</th>
                      <td mat-cell *matCellDef="let item">{{item.city}}</td>
                    </ng-container>
                    <ng-container matColumnDef="surveyDate">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Survey Date</th>
                      <td mat-cell *matCellDef="let item">{{item.surveyDate}}</td>
                    </ng-container>
                    <ng-container matColumnDef="type">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
                      <td mat-cell *matCellDef="let item">{{item.labType}}</td>
                    </ng-container>
                    <ng-container matColumnDef="fuDue">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>FU Due</th>
                      <td mat-cell *matCellDef="let item">{{item.fuDue}}</td>
                    </ng-container>
                    <ng-container matColumnDef="fuDone">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>FU Done</th>
                      <td mat-cell *matCellDef="let item">{{item.fuDone}}</td>
                    </ng-container>
                    <ng-container matColumnDef="deficiencies">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Deficiencies</th>
                      <td mat-cell *matCellDef="let item">{{item.deficiencies}}</td>
                    </ng-container>
                    <ng-container matColumnDef="surveyors">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Surveyors</th>
                      <td mat-cell *matCellDef="let item">{{item.surveyors}} {{item.surveyors1}}</td>
                    </ng-container>
                    <ng-container matColumnDef="conditionLevel">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Condition Level</th>
                      <td mat-cell *matCellDef="let item">{{item.conditionLevel}}</td>
                    </ng-container>
                    <ng-container matColumnDef="paid">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Paid</th>
                      <td mat-cell *matCellDef="let item">{{item.paid}}</td>
                    </ng-container>


                    <tr mat-header-row *matHeaderRowDef="surveyColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: surveyColumns;"></tr>
                  </table>
                </div>
              </div>
            </div>

          </mat-card-content>

        </mat-card>
      </div>

    </div>

    <!-- FollowUp Report -->
    <div class="flex flex-col" *ngIf="reportMode == 'followup'">
      <div class="flex flex-row">
        <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
          'bg-gray-700': sharedService.userTheme === 'dark',
          'bg-indigo-50': sharedService.userTheme === 'light'}">
          <mat-card-content>
            <div class="flex flex-col">
              <h5>Labs with follow up done within the last 6 months. ({{list.length}})</h5>
              <div class="flex flex-row" style="padding-bottom: 10px;" *ngIf="list.length > 0">
                <div style="padding-right: 10px;">
                  <button type="button" mat-raised-button (click)="csv('followup')">
                    CSV
                  </button>
                </div>
                <!-- <div>
                  <button type="button" mat-raised-button (click)="pdf.saveAs('FollowupReport.pdf')">
                    PDF
                  </button>
                </div> -->
              </div>
              <div style="overflow-x:auto">
                <div class="flex flex-row" *ngIf="list.length > 0">
                  <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort #TableSort="matSort"
                    class="mat-elevation-z8 w-full">
                    <ng-container matColumnDef="stateNumber">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>State #</th>
                      <td mat-cell *matCellDef="let item">{{item.scheduleType}} {{item.stateNumber}}</td>
                    </ng-container>
                    <ng-container matColumnDef="cliaNumber">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Clia #</th>
                      <td mat-cell *matCellDef="let item">{{item.cliaNumber}}</td>
                    </ng-container>
                    <ng-container matColumnDef="labName">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Lab Name</th>
                      <td mat-cell *matCellDef="let item">{{item.labName}}</td>
                    </ng-container>
                    <ng-container matColumnDef="city">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>City</th>
                      <td mat-cell *matCellDef="let item">{{item.city}}</td>
                    </ng-container>
                    <ng-container matColumnDef="address">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Address</th>
                      <td mat-cell *matCellDef="let item">{{item.address}}</td>
                    </ng-container>
                    <ng-container matColumnDef="surveyDate">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Survey Date</th>
                      <td mat-cell *matCellDef="let item">{{item.surveyDate}}</td>
                    </ng-container>
                    <ng-container matColumnDef="type">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
                      <td mat-cell *matCellDef="let item">{{item.labType}}</td>
                    </ng-container>
                    <ng-container matColumnDef="fuDue">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>FU Due</th>
                      <td mat-cell *matCellDef="let item">{{item.fuDue}}</td>
                    </ng-container>
                    <ng-container matColumnDef="fuDone">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>FU Done</th>
                      <td mat-cell *matCellDef="let item">{{item.fuDone}}</td>
                    </ng-container>
                    <ng-container matColumnDef="hoursOnSite">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Hours Onsite</th>
                      <td mat-cell *matCellDef="let item">{{item.hoursOnSite}}</td>
                    </ng-container>
                    <ng-container matColumnDef="deficiencies">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Deficiencies</th>
                      <td mat-cell *matCellDef="let item">{{item.deficiencies}}</td>
                    </ng-container>
                    <ng-container matColumnDef="surveyors">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Surveyors</th>
                      <td mat-cell *matCellDef="let item">{{item.surveyors}} {{item.surveyors1}}</td>
                    </ng-container>
                    <ng-container matColumnDef="paid">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Paid</th>
                      <td mat-cell *matCellDef="let item">{{item.paid}}</td>
                    </ng-container>


                    <tr mat-header-row *matHeaderRowDef="followupColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: followupColumns;"></tr>
                  </table>
                </div>
              </div>
            </div>

          </mat-card-content>

        </mat-card>
      </div>

    </div>

    <!-- Registration Report -->
    <div class="flex flex-col" *ngIf="reportMode == 'registration'">
      <div class="flex flex-row">
        <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
          'bg-gray-700': sharedService.userTheme === 'dark',
          'bg-indigo-50': sharedService.userTheme === 'light'}">
          <mat-card-content>
            <div class="flex flex-col">
              <h5>Registration labs to be inspected ({{list.length}})</h5>
              <div class="flex flex-row" style="padding-bottom: 10px;" *ngIf="list.length > 0">
                <div style="padding-right: 10px;">
                  <button type="button" mat-raised-button (click)="csv('registration')">
                    CSV
                  </button>
                </div>
                <!-- <div>
                  <button type="button" mat-raised-button (click)="pdf.saveAs('RegistrationReport.pdf')">
                    PDF
                  </button>
                </div> -->
              </div>
              <div style="overflow-x:auto">
                <div class="flex flex-row" *ngIf="list.length > 0">
                  <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort #TableSort="matSort"
                    class="mat-elevation-z8 w-full">
                    <ng-container matColumnDef="stateNumber">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>State #</th>
                      <td mat-cell *matCellDef="let item">{{item.scheduleType}} {{item.stateNumber}}</td>
                    </ng-container>
                    <ng-container matColumnDef="labName">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Lab Name</th>
                      <td mat-cell *matCellDef="let item">{{item.labName}}</td>
                    </ng-container>
                    <ng-container matColumnDef="city">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>City</th>
                      <td mat-cell *matCellDef="let item">{{item.city}}</td>
                    </ng-container>
                    <ng-container matColumnDef="address">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Address</th>
                      <td mat-cell *matCellDef="let item">{{item.address}}</td>
                    </ng-container>
                    <ng-container matColumnDef="cliaExpirationDate">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>CLIA Expiration Date</th>
                      <td mat-cell *matCellDef="let item">{{item.cliaExpirationDate}}</td>
                    </ng-container>
                    <ng-container matColumnDef="cliaNumber">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Clia #</th>
                      <td mat-cell *matCellDef="let item">{{item.cliaNumber}}</td>
                    </ng-container>
                    <ng-container matColumnDef="paid">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Paid</th>
                      <td mat-cell *matCellDef="let item">{{item.paid}}</td>
                    </ng-container>
                    <ng-container matColumnDef="lastSurveyDate">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Survey Date</th>
                      <td mat-cell *matCellDef="let item">{{item.lastSurveyDate}}</td>
                    </ng-container>
                    <ng-container matColumnDef="surveyAfterDate">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Survey After Date</th>
                      <td mat-cell *matCellDef="let item">{{item.surveyAfterDate}}</td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="registrationColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: registrationColumns;"></tr>
                  </table>
                </div>
              </div>
            </div>

          </mat-card-content>

        </mat-card>
      </div>

    </div>

    <!-- Deficiency Report -->
    <div class="flex flex-col" *ngIf="reportMode == 'deficiency'">
      <div class="flex flex-row">
        <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
              'bg-gray-700': sharedService.userTheme === 'dark',
              'bg-indigo-50': sharedService.userTheme === 'light'}">
          <mat-card-content>
            <div class="flex flex-col">
              <h5>Survey Statistics {{type}} ({{list.length}})</h5>
              <div class="flex flex-row" style="padding-bottom: 10px;" *ngIf="list.length > 0">
                <div style="padding-right: 10px;">
                  <button type="button" mat-raised-button (click)="csv('deficiency')">
                    CSV
                  </button>
                </div>
                <!-- <div>
                  <button type="button" mat-raised-button (click)="pdf.saveAs('DeficiencyReport.pdf')">
                    PDF
                  </button>
                </div> -->
              </div>
              <div style="overflow-x:auto">
                <div class="flex flex-row" *ngIf="list.length > 0">
                  <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort #TableSort="matSort"
                    class="mat-elevation-z8 w-full">
                    <ng-container matColumnDef="deficiency">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Deficiency</th>
                      <td mat-cell *matCellDef="let item">{{item.deficiencies}}</td>
                    </ng-container>
                    <ng-container matColumnDef="zeroFourth">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>0%</th>
                      <td mat-cell *matCellDef="let item">{{item.zeroFourth}}</td>
                    </ng-container>
                    <ng-container matColumnDef="oneFourth">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>25%</th>
                      <td mat-cell *matCellDef="let item">{{item.oneFourth}}</td>
                    </ng-container>
                    <ng-container matColumnDef="twoFourth">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>50%</th>
                      <td mat-cell *matCellDef="let item">{{item.twoFourth}}</td>
                    </ng-container>
                    <ng-container matColumnDef="threeFourth">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>75%</th>
                      <td mat-cell *matCellDef="let item">{{item.threeFourth}}</td>
                    </ng-container>
                    <ng-container matColumnDef="fourFourth">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>100%</th>
                      <td mat-cell *matCellDef="let item">{{item.fourFourth}}</td>
                    </ng-container>
                    <ng-container matColumnDef="averagePercent">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Average Per</th>
                      <td mat-cell *matCellDef="let item">{{item.averagePercent | number: '1.1-1'}}</td>
                    </ng-container>
                    <ng-container matColumnDef="numTotal">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Total</th>
                      <td mat-cell *matCellDef="let item">{{item.numTotal}}</td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="deficiencyColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: deficiencyColumns;"></tr>
                  </table>
                </div>
              </div>
            </div>

          </mat-card-content>

        </mat-card>
      </div>

    </div>

    <!-- Unresolved Deficiencies Report -->
    <div class="flex flex-col" *ngIf="reportMode == 'unresolvedDeficiencies'">
      <div class="flex flex-row">
        <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
          'bg-gray-700': sharedService.userTheme === 'dark',
          'bg-indigo-50': sharedService.userTheme === 'light'}">
          <mat-card-content>
            <div class="flex flex-col">
              <h5>Incomplete Deficiencies ({{list.length}})</h5>
              <div class="flex flex-row" style="padding-bottom: 10px;" *ngIf="list.length > 0">
                <div style="padding-right: 10px;">
                  <button type="button" mat-raised-button (click)="csv('unresolvedDeficiencies')">
                    CSV
                  </button>
                </div>
                <!-- <div>
                  <button type="button" mat-raised-button (click)="pdf.saveAs('UnresolvedDeficienciesReport.pdf')">
                    PDF
                  </button>
                </div> -->
              </div>
              <div style="overflow-x:auto">
                <div class="flex flex-row" *ngIf="list.length > 0">
                  <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort #TableSort="matSort"
                    class="mat-elevation-z8 w-full">
                    <ng-container matColumnDef="surveyDate">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
                      <td mat-cell *matCellDef="let item">{{item.surveyDate}}</td>
                    </ng-container>
                    <ng-container matColumnDef="labId">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Lab ID</th>
                      <td mat-cell *matCellDef="let item">{{item.labId}}</td>
                    </ng-container>
                    <ng-container matColumnDef="labName">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Lab Name</th>
                      <td mat-cell *matCellDef="let item">{{item.labName}}</td>
                    </ng-container>
                    <ng-container matColumnDef="deficiency">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Deficiency</th>
                      <td mat-cell *matCellDef="let item">{{item.deficiencies}}</td>
                    </ng-container>
                    <ng-container matColumnDef="sod">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>SOD</th>
                      <td mat-cell *matCellDef="let item">{{item.sod}}</td>
                    </ng-container>
                    <ng-container matColumnDef="poc">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>POC</th>
                      <td mat-cell *matCellDef="let item">{{item.poc}}</td>
                    </ng-container>
                    <ng-container matColumnDef="inspector1">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Inspector 1</th>
                      <td mat-cell *matCellDef="let item">{{item.surveyors}}</td>
                    </ng-container>
                    <ng-container matColumnDef="inspector2">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Inspector 2</th>
                      <td mat-cell *matCellDef="let item">{{item.surveyors1}}</td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="unresolvedDeficienciesColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: unresolvedDeficienciesColumns;"></tr>
                  </table>
                </div>
              </div>
            </div>

          </mat-card-content>

        </mat-card>
      </div>

    </div>


  </kendo-pdf-export>
</div>